import axios from "axios";
import { tmsApi, localApi } from "../api";

export const getBooking = async (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(
        tmsApi +
        `v1/entities/booking/history/old?page=${obj.page}&size=${obj.size}`,
        obj,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getBookingById = async (bookingId) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(tmsApi + `v1/entities/booking/detail/${bookingId}`, config)
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    return error;
  }
};

export const getBookingCount = async (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(tmsApi + `v1/entities/booking/count`, obj, config)
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const postBooking = async (body) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(tmsApi + "v1/entities/booking", body, config)
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    return error;
  }
};

export const fetchLocation = async (obj) => {
  if (
    (obj.key === null || obj.key === undefined) &&
    Object.keys(obj.address).length === 0
  ) {
    return null;
  }
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
    .post(tmsApi + `locationservice/fetchlocation/new`,obj, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getBookingStatus = () => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(tmsApi + "v1/entities/booking/status", config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getBookingViaType = () => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(tmsApi + "v1/entities/booking/via/type", config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getCancelReasons = () => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(tmsApi + "v1/entities/cancelreason", config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const cancelTrip = (body) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .put(tmsApi + "v1/services/cancelride", body, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const editTripData = (body) => {
  const config = {
    headers: {
      // Authorization: `Bearer ${localStorage.getItem("token")}`,
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .put(tmsApi + "v1/entities/booking", body, config)
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverDetails = (driverId) => {
  const config = {
    headers: {
      // Authorization: `Bearer ${localStorage.getItem("token")}`,
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(tmsApi + `v1/entities/driver/detail/${driverId}`, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getCoupons = (obj) => {
  const config = {
    headers: {
      // Authorization: `Bearer ${localStorage.getItem("token")}`,
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(tmsApi + `v1/entities/coupon/list/${obj.serviceCityId}?rideType=${obj.rideType}`, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const searchCoupon = (obj) => {
  const config = {
    headers: {
      // Authorization: `Bearer ${localStorage.getItem("token")}`,
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(tmsApi + `v1/entities/coupon/search/${obj.serviceCityId}?code=${obj.couponCode}&rideType=${obj.rideType}`, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const applyCoupon = (obj) => {
  const config = {
    headers: {
      // Authorization: `Bearer ${localStorage.getItem("token")}`,
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(tmsApi + `v1/entities/coupon/apply`, obj, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const removeCoupon = (obj) => {
  const config = {
    headers: {
      // Authorization: `Bearer ${localStorage.getItem("token")}`,
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .delete(tmsApi + `v1/entities/coupon/remove`, obj, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getApplicableOffers = (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(tmsApi + `v1/offers/applicable`, obj, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const applyOffer = (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(tmsApi + `v1/offers/apply`, obj, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const fetchFareEstimation = async (body) => {
  const config = {
    headers: {
      // Authorization: `Bearer ${localStorage.getItem("token")}`,
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(tmsApi + "v1/services/estimatefareTMS", body, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getTimeLogForBooking = async (body) => {
  const config = {
    headers: {
      // Authorization: `Bearer ${localStorage.getItem("token")}`,
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(
        tmsApi + `v1/entities/loggingbookingactivitylist/${body.bookingNumber}`,
        config
      )
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }

  // try {
  //   return axios.get(localApi + `timeLog.json`,config).then((resp) => {
  //     return resp;
  //   });
  // } catch (error) {
  //   console.log("error", error);
  // }
};

export const filterCustomers = async (value) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(tmsApi + `v1/entities/search/customer/${value}`, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
    return error;
  }
};

export const findPickupType = async (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(tmsApi + `v1/entities/booking/find/pickupType`, obj, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
    return error;
  }
};

export const getBookingTableFilterData = async (obj, body) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(
        tmsApi + `v1/entities/booking/filter/old?page=${obj.page}&size=${obj.size}`,
        body,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getBookingTableSearchData = async (obj, body) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(
        tmsApi + `v1/entities/booking/search/old?page=${obj.page}&size=${obj.size}`,
        body,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};
